import React, {FC} from 'react';
import ReloadLink from 'components/Header/ReloadLink';
import {Routes} from 'constants/index';

import LogoSVG from './svgs/logo.svg';

import * as styles from './styles.module.scss';

const Logo: FC = () => {
	return (
		<ReloadLink to={Routes.home} className={styles.logo} >
			<img src={LogoSVG as string} alt='BodySpec Logo' />
		</ReloadLink>
	);
};

export default Logo;

